// src/components/ProcessWarning.js
import React from 'react';

const ProcessWarning = ({ open, onCancel, onContinue }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-md max-w-sm w-full mx-4">
        <h3 className="text-xl font-semibold mb-4">Leave Page?</h3>
        <p className="text-gray-700 mb-6">
          Your request is in progress. Are you sure you want to leave this page?
        </p>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onCancel}
            className="px-4 py-2 rounded-md border hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            onClick={onContinue}
            className="px-4 py-2 rounded-md bg-black text-white hover:bg-gray-800"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProcessWarning;